import { IApi, Api } from "../../utilities/Api";

import * as ACTIONCONTANTS from "./ActionConstants";
import { ApiRequest } from "../../utilities/ApiRequest";
import LMSDispatcher from "../LMSDispatcher";
import { IInstrumentTypeListViewData, InstrumentTypeListViewData } from "../../models/instrumentType/InstrumentTypeListViewData";
import InstrumentTypeViewData, { IInstrumentTypeViewData } from "../../models/instrumentType/InstrumentTypeViewData";
import PropertyViewData, { IPropertyViewData } from "../../models/property/PropertyViewData";
import IInstrumentTypeFormData from "../../models/instrumentType/InstrumentTypeFormData";
import * as CONSTANTS from "../../utilities/Constants";
import i18next from "i18next";

class InstrumentTypeActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT)
    }

    async getById(id: string) {
        try {
            const request = new ApiRequest("/instrumenttype/" + id, "", null, i18next.t("Instrument Type not found."));
            const result = await this.api.get(request);
            const payload = this.convertResponseData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_TYPE_GET_BY_ID,
                payload: {
                    data: payload
                }
            });
        } catch (error) {
            throw error;
        }

    }

    async getAll(page: number, pageSize: number, sort: string, order: string, filter: string) {
        try {
            const request = new ApiRequest(`/instrumenttype/${page}/${pageSize}/${sort}/${order}/${filter}`, "", null, i18next.t("Unable to fetch instrument types."));
            const result = await this.api.get(request);
            const payload = this.convertResponseListData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_TYPE_GET_ALL,
                payload: {
                    data: payload
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async post(data: IInstrumentTypeFormData): Promise<void> {
        try {
            const payload: any = this.preparePostPayload(data);

            const request = new ApiRequest("/instrumenttype", data.requestId, payload, i18next.t("Instrument type created."));
            const result = await this.api.post(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_TYPE_SUBMIT,
                payload: {
                    id: result.data,
                    message: result.message
                }
            })
        } catch (error) {
            throw error;
        }
    }

    async put(data: IInstrumentTypeFormData): Promise<void> {
        try {
            const payload: any = this.preparePutPayload(data);

            const request = new ApiRequest("/instrumenttype/", data.requestId, payload, i18next.t("Instrument type updated."));
            const result = await this.api.put(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_TYPE_SUBMIT,
                payload: {
                    id: data.id,
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async delete(id: string, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/instrumenttype/" + id, requestId, undefined, i18next.t("Instrument type deleted."));
            const result = await this.api.delete(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_TYPE_DELETE,
                payload: {
                    reload: true,
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    private preparePostPayload(data: IInstrumentTypeFormData): any {
        // Process new properties
        const properties = this.processProperties(data.properties);

        return {
            name: data.name,
            description: data.description,
            properties
        };
    }

    private preparePutPayload(data: IInstrumentTypeFormData): any {
        const properties = this.processProperties(data.properties);

        return {
            id: data.id,
            name: data.name,
            description: data.description,
            properties
        };
    }

    private processProperties(data: IPropertyViewData[]): any[] {
        const properties: any[] = [];
        data.forEach((item) => {
            if (item.id.includes("new")) {
                properties.push({
                    id: CONSTANTS.DefaultGuid,
                    name: item.name,
                    propertyTypeId: item.typeId,
                    customId: item.customId,
                    unit: item.unit,
                    decimals: item.decimal,
                    description: item.description
                });
            } else {
                properties.push({
                    id: item.id,
                    name: item.name,
                    propertyTypeId: item.typeId,
                    customId: item.customId,
                    unit: item.unit,
                    decimals: item.decimal,
                    description: item.description
                });
            }
        });

        return properties;
    }

    private convertResponseData(data: any): IInstrumentTypeViewData {
        const properties: IPropertyViewData[] = [];
        data.properties.forEach((element: any) => {
            properties.push(new PropertyViewData(element.id, element.name, element.description, element.customId,
                element.type.name, element.type.id, element.unit, element.decimals));
        });
        return new InstrumentTypeViewData(data.id, data.name, data.description, properties);
    }

    private convertResponseListData(data: any) {
        const result: IInstrumentTypeListViewData[] = [];
        if (data.contents) {
            data.contents.forEach((element: { id: string; name: string; description: string; instrumentDetails: any[]; createdOn: string}) => {
                result.push(new InstrumentTypeListViewData(element.id, element.name, element.description, element.instrumentDetails,element.createdOn));
            });
        }
        else {
            data.forEach((element: { id: string; name: string; description: string; instrumentDetails: any[]; createdOn: string}) => {
                result.push(new InstrumentTypeListViewData(element.id, element.name, element.description, element.instrumentDetails,element.createdOn));
            });
        }
        const tempResult = {
            result : data.contents ? result : result,
            currentPage: data.contents ? data.currentPage : 0,
            totalPages: data.contents ?  data.totalPages : 0,
            totalRecords: data.contents ?  data.totalRecords : 0
        }
        return tempResult;
    }
}

const instrumentTypeActions = new InstrumentTypeActions();
export default instrumentTypeActions;